// Consolidates per-card VisualArtwork schema.org data (stored as a
// data-schema attribute by blocks/artwork-item.liquid) into a single
// JSON-LD <script> tag, instead of one inline script per gallery card.
// Runs once per page load; a no-op on pages without gallery items.
(() => {
  const run = () => {
    const items = document.querySelectorAll('[data-gallery-item][data-schema]');
    if (!items.length) return;

    // Avoid duplicating work if this ever runs more than once on the page.
    if (document.getElementById('artwork-schema-aggregate')) return;

    const entries = [];
    items.forEach((el) => {
      const raw = el.getAttribute('data-schema');
      if (!raw) return;
      try {
        entries.push(JSON.parse(raw));
      } catch (e) {
        // Skip malformed entries rather than breaking the whole page.
      }
    });

    if (!entries.length) return;

    const payload = {
      '@context': 'https://schema.org',
      '@graph': entries,
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'artwork-schema-aggregate';
    script.textContent = JSON.stringify(payload);
    document.head.appendChild(script);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
